/* 
-----------------------------------------------------------------------------
| TABLE LAYOUT PAGE
-----------------------------------------------------------------------------
- description: no booking data logic goes here, just metrics, redirects etc.
*/
import { FC, useEffect } from "react";
import { useApp } from "../context/useApp";
import { ROUTES } from "../utils/symbols";
import { _ } from "../utils/helpers";
import { TableLayoutPageWithoutTables } from "./TableLayoutPageWithoutTables";
import { TableLayoutPageWithTables } from "./TableLayoutPageWithTables";

export const TableLayoutPage: FC = () => {

    const {
        state: { booking },
        actions: { navigate }
    } = useApp()

    useEffect(() => {

        if (booking.step === 'date') {navigate(ROUTES.DATE); return}

    }, [])

    return booking.hasTableSelection() ?
        <TableLayoutPageWithTables /> :
        <TableLayoutPageWithoutTables />
}